<div class="p-8 flex flex-col gap-8 max-h-[90vh] overflow-y-auto">
  <div class="flex justify-end -mb-5">
    <button dialogClose>
      <img src="/assets/images/icons/close-dialog.svg" alt="Close" />
    </button>
  </div>

  @if (!isOrganizationOwner()) {
    <div class="flex justify-center">
      <img
        ngSrc="/assets/images/brand/safehire-placeholder.png"
        class="w-40 h-40 object-cover mb-4"
        alt="Safehire"
        width="160"
        height="160"
        priority
      />
    </div>
  }

  <h1 class="!text-2xl font-semibold text-center">
    @if (isOrganizationOwner()) {
      {{ 'membership.plans.title' | transloco }}
    } @else {
      {{ 'membership.plans.readonly.title' | transloco }}
    }
  </h1>

  @if (isOrganizationOwner()) {
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      @for (product of products; track product.id) {
        <app-subscription-plan-card
          [product]="product"
          [cyberExposureProducts]="cyberExposureProducts"
          (startSubscription)="createCheckout($event)"
        />
      }
    </div>
  } @else {
    <p class="text-center">{{ 'membership.plans.readonly.description' | transloco }}</p>
  }
</div>
